/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Submission_FailedInputs */

const en_audit_submission_failed = /** @type {(inputs: Audit_Submission_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit submission failed`)
};

const es_audit_submission_failed = /** @type {(inputs: Audit_Submission_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al enviar la auditoria`)
};

/**
* | output |
* | --- |
* | "Audit submission failed" |
*
* @param {Audit_Submission_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_submission_failed = /** @type {((inputs?: Audit_Submission_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Submission_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_submission_failed(inputs)
	return es_audit_submission_failed(inputs)
});